import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  static values = { eventName: String, eventProperties: Object }

  connect() {
    if (!this.hasEventNameValue) return

    const eventTracker = new EventTrackerService()
    eventTracker.initialize()
    eventTracker.trackEvent(this.eventNameValue, this.hasEventPropertiesValue ? this.eventPropertiesValue : {}, this.element)
  }
}
